const Datasheet = {

    // LABELS
    "datasheet": "Datasheet",
    "department": "Department",
    "equipment": "Equipment",
    "part_number": "Part Number",
    "document": "Document",
    "search": "Search",

    // TABLE
    "table_department": "DEPARTMENT",
    "table_equipment": "EQUIPMENT",
    "table_part_number": "PART NUMBER",
    "table_document": "DOCUMENT",

    // ERRORS
    "error_department": "Select Department",
    "error_equipment": "Select Equipment",
    "error_part_number": "Enter Part Number",
    "error_document": "Upload Document",

}

export default Datasheet;